import { ViewStream } from 'spyne';
import  AIPromptTmpl  from './templates/ai-prompt.tmpl.html'
import {AIViewTraits} from 'traits/ai-view-traits.js';

export class AIPromptView extends ViewStream {
  constructor(props = {}) {
    props.channels = ["CHANNEL_UI"]
    props.traits = [AIViewTraits];
    props.template = AIPromptTmpl;
    super(props);
  }

  addActionListeners() {
    return [
      ['CHANNEL_UI_CLICK_EVENT', 'aiView$CopyPrompt', '.ai-copy-button']
    ]
  }

  broadcastEvents() {
    return [
      ['button.ai-copy-button', 'click']
    ];
  }

  onRendered() {
    console.log('prompt view is ',this.props);

  }
}
